import react, { Fragment } from "react";
import "./FileUploadPage.scss";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Box, Button, Dialog } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import {
  bulkUploadImportFileService,
  bulkUploadProcessFileService,
  bulkUploadService,
  getSampleFileService,
  importFilesService,
  removeFileService,
} from "../../services/emissionService";
import { dateParser, downloadXLSFile, toastMessage } from "../../helper";
import { useNavigate } from "react-router-dom";
import { successMessage } from "../../constants/messageConstants";
import { neutral, primaryColor } from "../../constants/colorConstants";
import { TablePagination } from "@material-ui/core";
import ErrorSummary from "../EmissionLog/ErrorSummary/ErrorSummary";
import CircularProgress from "@mui/material/CircularProgress";
import { seterrorFile } from "../../actions/fileAction";
import { useDispatch } from "react-redux";
import { setErrorsByFile } from "../../services/emissionService";
import { FILE_STATUS, STEPS } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import CategoryMapping from "../CategoryMapping/CategoryMapping";
// const RenderUploadDetails = () => {

// };

const FileUpload = (props: any) => {
  const { t, i18n } = useTranslation();
  const {
    selectedCategory,
    setStep,
    categoryPreferences,
    setUploadedFiles,
    setShowErrorDialog,
    isDirectEmissionApprovalEnable,
  } = props;
  const [selectedIsoCategory, setSelectedIsoCategory] = useState<any>(null);
  const dispatch = useDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [allFiles, setAllFiles] = useState([] as any);
  const [file, setFile] = useState();
  const [fileErrors, setFileErrors] = useState([]);
  const [filesCount, setFilesCount] = useState(0);
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  const [open, setOpen] = useState(false);
  let [isAutoMapCompleted, setIsAutoMapCompleted] = useState(false);
  let fileDetails: any;

  useEffect(() => {
    if (isAutoMapCompleted) {
      setShowMappingDialog(false);
      processFile(currentFile);
    }
  }, [isAutoMapCompleted]);
  const downloadSampleFile = () => {
    let reqData = {} as any;
    if (categoryPreferences) {
      let categoryPreference = categoryPreferences.find(
        (eachPreference: any) =>
          eachPreference[
            localStorage.getItem("protocol") == "ghg"
              ? "ghgCategory"
              : "category"
          ] === selectedIsoCategory.id
      );
      if (categoryPreference) {
        reqData.emission_type = categoryPreference.emissionType;
        reqData.category = categoryPreference.category;
        reqData.emission_sub_type = categoryPreference.emissionSubType;

        reqData.emission_method = selectedIsoCategory.method
          ? selectedIsoCategory.method
          : categoryPreference.methods.find((each: any) => each.selected).id;
      }
    } else {
      reqData["type_name"] = props.typeName;
    }
    getSampleFileService(reqData)
      .then((res: any) => {
        downloadXLSFile(res.data.filePath);
      })
      .catch((err) => toastMessage(err.response.data.message, "error"));
  };

  const [isUploading, setIsUploading] = useState(false);
  const handleChange = (event: any) => {
    if (
      (event.target.files.length > 0 &&
        event.target.files[0].name.includes(".csv")) ||
      event.target.files[0].name.includes(".xls") ||
      event.target.files[0].name.includes(".xlsx")
    ) {
      //
      // setFiles(event.target.files[0]);

      //    const files = allFiles;
      //    files.push([...allFiles, event.target.files[0]]);

      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append(
        "type",
        props.typeName ? props.typeName : "Emission Activities"
      );
      bulkUploadService(formData).then((res) => {
        let categoryPreference;
        if (categoryPreferences && categoryPreferences.length) {
          categoryPreference = categoryPreferences.find(
            (eachPreference: any) =>
              eachPreference.category === selectedIsoCategory.id
          );
        }
        let reqData = {} as any;
        reqData.originalName = res.data.key;
        reqData.fileName = res.data.key;
        reqData.filePath = res.data.Location;
        reqData.company = JSON.parse(localStorage.getItem("company") || "").id;
        reqData.typeName = props.typeName;
        let user = JSON.parse(localStorage.getItem("user") || "{}");
        reqData.ownerName = user.displayName
          ? user.displayName
          : user.email.split("@")[0];
        if (categoryPreference) {
          reqData.emissionType = categoryPreference.emissionType;
          reqData.category = categoryPreference.category;
          reqData.emissionSubType = categoryPreference.emissionSubType;
          reqData.emissionMethod = selectedIsoCategory.method
            ? selectedIsoCategory.method
            : categoryPreference.methods.find((each: any) => each.selected).id;
          reqData.businessUnit = JSON.parse(
            localStorage.getItem("currentBusinessUnit") || ""
          ).id;
          reqData.typeName = "Emission Activities";
        }
        bulkUploadImportFileService(reqData).then((res1) => {
          const reqObj: any = {
            controller: controller,
            type_name: props.typeName,
            isCompanyLevel: props.typeName == "Suppliers",
          };
          if (selectedIsoCategory) {
            reqObj["category"] = selectedIsoCategory.id;
            reqObj["type_name"] = "Emission Activities";
          }
          importFilesService(reqObj)
            .then((res) => {
              setAllFiles([...res.data.files]);
            })
            .catch((err) => {
              console.log(err);
            });
        });
      });
    } else {
      toastMessage("Upload csv or xlsx file only", "error");
    }
  };
  let [currentFile, setCurrentFile] = useState<any>(null);
  let [showAIDialog, setShowAIDialog] = useState<boolean>(false);
  let [showMappingDialog, setShowMappingDialog] = useState<boolean>(false);
  const processFile = (file: any) => {
    const { id, owner_name } = file;
    setCurrentFile(file);
    let categoryPreference = categoryPreferences.find(
      (eachPreference: any) =>
        eachPreference.category === selectedIsoCategory.id
    );
    if (
      selectedIsoCategory.id == 23 &&
      365 == categoryPreference.emissionSubType &&
      !isAutoMapCompleted &&
      !proceedWithoutAI
    ) {
      setShowAIDialog(true);
      return;
    } else {
      setShowAIDialog(false);
    }
    setIsUploading(true);
    bulkUploadProcessFileService({
      importFileId: id,
      displayName: owner_name,
      emissionStatus: isDirectEmissionApprovalEnable ? "Approved" : "Pending",
      typeName: props.typeName ? props.typeName : "Emission Activities",
      isAiAutomap: isAutoMapCompleted,
    })
      .then((res) => {
        setIsUploading(false);
        if (setUploadedFiles) {
          setUploadedFiles(res.data);
        }
        fileDetails = res.data;
        if (res.data.errors && Object.keys(res.data.errors).length > 0) {
          dispatch(seterrorFile(res.data));
          setShowErrorDialog(true);
        }
        setController({ ...controller });
        // toastMessage("Started File Processing");
        // setEmissionData(res.data );
        if (selectedIsoCategory) {
          toastMessage(successMessage().EMISSION_SUCCESS, "success");
          setStep(STEPS.EMISSION_SUMMARY);
        } else {
          toastMessage("Upload sucessful", "success");
        }
        // navigate("/Log/Emissions");
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
        setController({ ...controller });
      });
  };

  const proceedToUpload = () => {
    setShowAIDialog(false);
    setProceedWithoutAI(true);
    processFile(currentFile);
  };

  let [proceedWithoutAI, setProceedWithoutAI] = useState(false);

  const handleClick = () => {
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const handleDrop = (event: any) => {
    event.preventDefault();
    event.target.files = event.dataTransfer.files;
    handleChange(event);
  };
  useEffect(() => {
    // if (categoryPreferences) {
    let categoryPreference = categoryPreferences.find(
      (eachPreference: any) =>
        eachPreference[
          localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category"
        ] === selectedCategory.id
    );
    setSelectedIsoCategory({
      id: categoryPreference.category,
      method: selectedCategory.method,
    });
    // }
  }, [controller]);

  useEffect(() => {
    const reqObj: any = {
      controller: controller,
      type_name: "",
    };
    if (selectedIsoCategory) {
      reqObj.type_name = "Emission Activities";
      reqObj["category"] = selectedIsoCategory.id;
    } else if (props.typeName) {
      reqObj.type_name = props.typeName;
      reqObj.isCompanyLevel = true;
    }
    importFilesService(reqObj)
      .then((res) => {
        setAllFiles([...res.data.files]);
        setFilesCount(res.data.total_count);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedIsoCategory]);

  const processWithAI = () => {
    setShowAIDialog(false);
    setShowMappingDialog(true);
    setProceedWithoutAI(false);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const handleRemove = (fileID: any) => {
    const reqObj = {
      id: fileID,
      isDelete: true,
    };
    removeFileService(reqObj).then((res) => {
      setController({ ...controller });
    });
  };

  const handleDialog = (fileID: number) => {
    const file = allFiles.find((each: any) => each.id === fileID);
    setFileErrors(setErrorsByFile(file));
    setOpen(true);
  };
  return (
    <>
      {open && (
        <Dialog open={open} fullWidth maxWidth="xl">
          <ErrorSummary
            setOpen={setOpen}
            fileErrors={fileErrors}
            categoryID={selectedIsoCategory ? selectedIsoCategory.id : null}
            controller={controller}
          />
        </Dialog>
      )}
      {!open && (
        <Fragment>
          <div className="pw-file-main w-55v overflow-y-auto">
            <Fragment>
              {
                <div
                  className="pw-dragfile flex flex-col items-center  bg-white min-h-50v"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <div className="flex flex-col items-center gap-8">
                    <FileUploadIcon className="pw-file-icon text-neutral-300" />
                    <p className="text-neutral-500">{t("Drag&Drop")}</p>
                    <div className="flex flex-row gap-4 w-full">
                      <hr className="pw-file-line" />
                      <p className="text-sm text-neutral-500">{t("OR")}</p>
                      <hr className="pw-file-line" />
                    </div>
                    <input
                      type="file"
                      hidden
                      multiple
                      ref={inputRef}
                      onChange={handleChange}
                    />
                    <Button
                      className="pw-upload-button"
                      variant="outlined"
                      onClick={handleClick}
                    >
                      <FileUploadIcon />
                      {t("Upload")}
                    </Button>
                    <div className="flex flex-col gap-1 items-center text-center">
                      <p className="text-xs">{t("FileUploadMessage")}</p>
                      <p
                        className="font-bold text-primary cursor-pointer"
                        onClick={downloadSampleFile}
                      >
                        {t("Sample File")}
                      </p>
                    </div>
                  </div>
                </div>
              }
            </Fragment>

            <div>
              <div className="flex flex-col gap-8 pt-4 pw-e2e-uploadedfiles">
                {allFiles.map((file: any) => {
                  return (
                    <div
                      key={file.id}
                      className="flex flex-row justify-between items-center px-4 pw-file-status"
                      style={{
                        border:
                          file.status === FILE_STATUS.YET_TO_START
                            ? "2px dashed"
                            : "1px solid",
                        borderColor:
                          file.status === FILE_STATUS.YET_TO_START
                            ? primaryColor
                            : neutral[300],
                      }}
                    >
                      <div className="text-sm text-neutral-900 font-bold w-[40%] e2e-pw-uploadedfilename">
                        {file.original_name}
                      </div>
                      {file.status !== FILE_STATUS.YET_TO_START &&
                        Object.keys(file?.errors).length === 0 && (
                          <div className="flex flex-row items-center gap-2">
                            <img src="assets/icons/success.svg" alt=" " />
                            <div className="text-sm text-neutral-600">
                              {file.size == null || file.size == 0 ? (
                                "No records uploaded"
                              ) : (
                                <>
                                  {file.size - Object.keys(file?.errors).length}
                                  /{file.size} {t("records uploaded")}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      {file.status !== FILE_STATUS.YET_TO_START &&
                        Object.keys(file?.errors).length > 0 &&
                        Object.keys(file?.errors).length < file.size && (
                          <div className="flex flex-col items-center justify-start">
                            <div className="flex flex-row items-center gap-2">
                              <img src="assets/icons/warning.svg" alt=" " />
                              <div className="text-sm text-neutral-600">
                                {file.size - Object.keys(file?.errors).length}/
                                {file.size} {t("records uploaded")}
                              </div>
                            </div>
                            <div className="text-sm flex flex-row gap-1">
                              <p
                                onClick={() => {
                                  handleDialog(file.id);
                                }}
                                className="underline cursor-pointer"
                              >
                                {t("Click")}
                              </p>
                              <p>{t("view the records with errors")}</p>
                            </div>
                          </div>
                        )}
                      {file.status !== FILE_STATUS.YET_TO_START &&
                        Object.keys(file?.errors).length > 0 &&
                        Object.keys(file?.errors).length === file.size && (
                          <div className="flex flex-col items-center justify-start">
                            <div className="flex flex-row items-center gap-2">
                              <img src="assets/icons/error.svg" alt=" " />
                              <div className="text-sm text-error-500">
                                {file.size - Object.keys(file?.errors).length}/
                                {file.size} {t("records uploaded")}
                              </div>
                            </div>
                            <div className="text-sm flex flex-row gap-1">
                              <p
                                onClick={() => {
                                  handleDialog(file.id);
                                }}
                                className="underline cursor-pointer"
                              >
                                {t("Click")}
                              </p>
                              <p>{t("view the records with errors")}</p>
                            </div>
                          </div>
                        )}
                      {file.status === FILE_STATUS.YET_TO_START && (
                        <>
                          {!isUploading && (
                            <div className="flex flex-row items-center gap-2">
                              <div
                                className="pw-editbox-bulk items-end cursor-pointer"
                                style={{
                                  border: "1px solid",
                                  borderColor: neutral[300],
                                }}
                                onClick={() => {
                                  handleRemove(file.id);
                                }}
                              >
                                <div className="text-xs !text-neutral-900 font-bold">
                                  {t("Remove")}
                                </div>
                              </div>
                              <div
                                className="pw-editbox-bulk items-end cursor-pointer"
                                onClick={() => processFile(file)}
                                style={{
                                  border: "1px solid",
                                  borderColor: primaryColor,
                                }}
                              >
                                <div className="text-xs !text-primary font-bold pw-e2w-startuploadbtn">
                                  {t("Start Upload")}
                                </div>
                              </div>
                            </div>
                          )}
                          {isUploading && (
                            <div className="flex flex-row gap-2 items-center">
                              <p className="text-sm text-neutral-700">
                                {t("Uploading")}
                              </p>
                              <Box sx={{ display: "flex" }}>
                                <CircularProgress
                                  style={{
                                    color: primaryColor,
                                    width: "1.5rem",
                                    height: "1.5rem",
                                  }}
                                />
                              </Box>
                            </div>
                          )}
                        </>
                      )}
                      {file.status !== FILE_STATUS.YET_TO_START && (
                        <p className="text-neutral-500 text-xs">
                          {dateParser(file.created)}
                        </p>
                      )}
                    </div>
                  );
                  //return <RenderUploadDetails />;
                })}
              </div>
              {filesCount > 10 && (
                <TablePagination
                  className="flex justify-end items-center pw-pagination"
                  component="div"
                  count={filesCount}
                  page={controller.page}
                  onPageChange={handlePageChange}
                  rowsPerPage={controller.limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage=""
                />
              )}
            </div>
          </div>
          <div className="flex flex-row justify-end pw-scope-footer w-full gap-6">
            <div
              className="pw-scope-button-light pw-scope-button-cancel text-neutral bg-white font-bold"
              onClick={() => {
                props.typeName === "Suppliers"
                  ? navigate("/partners/suppliers/list")
                  : navigate("/log/emissions");
              }}
            >
              {t("Close")}
            </div>
          </div>
        </Fragment>
      )}
      <Dialog open={showAIDialog}>
        <div style={{ padding: "20px" }}>
          <div
            style={{ float: "right" }}
            className="cursor-pointer"
            onClick={() => setShowAIDialog(false)}
          >
            <CloseIcon className="pw-color-close-attchments" />
          </div>
          <br />
          <div>
            <div style={{ textAlign: "center" }}>
              If the commodity provided adheres to planetwise classification
              then proceed normally otherwise you can you use ai to automap to
              corresponding category.
            </div>
            <br />
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Button
                onClick={processWithAI}
                style={{ color: "white" }}
                variant="contained"
              >
                Match using AI
              </Button>
              <Button
                onClick={proceedToUpload}
                style={{ color: "white" }}
                variant="contained"
              >
                Proceed to upload
              </Button>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog className="pw-cat-map" open={showMappingDialog}>
        <div style={{ padding: "20px", width: "100%" }}>
          <div
            style={{ float: "right" }}
            className="cursor-pointer"
            onClick={() => setShowMappingDialog(false)}
          >
            <CloseIcon className="pw-color-close-attchments" />
          </div>
          <br />
          <CategoryMapping
            file={currentFile}
            proceedToUpload={setIsAutoMapCompleted}
          ></CategoryMapping>
        </div>
      </Dialog>
    </>
  );
};

export default FileUpload;
